import {
    Link,
    useNavigate
  } from "react-router-dom";

import { useDispatch } from 'react-redux'

import {Card, Typography, Box} from '@mui/material'

import {
    faChartLine, faLeaf, faGraduationCap, faFutbol, faUsers,
    faFlaskVial, faGlobe, faMasksTheater, faHeartbeat, faGavel,
    faMicrochip,
    faWifi,
    faTrashCan
} from '@fortawesome/free-solid-svg-icons';

import useStyles from '../../../../styles/global-mui.js';
import { deleteLive } from '../../../../actions/lives.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DsasButton from "../../../../v1/components/DsasButton/DsasButton.js";
import { PERMISSIONS } from "../../../../permissions/permissionKeys.js";
import { Can } from "../../../../permissions/Can.js";
import { confirmActionNotification } from "../../../../actions/notifications.js";
import { useNotifications } from "../../../../v2/notifications/NotificationManager.js";
import LiveExport from "../../../Live/LiveExport.js";
import { GET_LIVE_DETAILS } from "../../../../constants/actionTypes.js";

const Live = ({ live, setCurrentId, reload }) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const classes = useStyles();

    const {addNotification} = useNotifications()

     
    const getDisciplineIcon = () => {
        switch (live.discipline) {
            case 'economie':
                return faChartLine;
            case 'environnement':
                return faLeaf;
            case 'education':
                return faGraduationCap;
            case 'sport':
                return faFutbol;
            case 'societe':
                return faUsers;
            case 'science':
                return faFlaskVial;
            case 'international':
                return faGlobe;
            case 'culture':
                return faMasksTheater;
            case 'sante':
                return faHeartbeat;
            case 'politique':
                return faGavel;
            case 'technologie':
                return faMicrochip;
            default:
                return faGlobe; // fallback
        }
    };

    const getCategoryClassName = () => {
        switch(live.discipline){
            case 'economie':
                return 'economie-title';
            case 'environnement':
                return 'environnement-title';
            case 'education':
                return 'education-title';
            case 'sport':
                return 'sport-title';
            case 'societe':
                return 'societe-title';
            case 'science':
                return 'science-title';
            case 'international':
                return 'international-title';
            case 'culture':
                return 'culture-title';
            case 'sante':
                return 'sante-title';
            case 'politique':
                return 'politique-title';
            case 'technologie':
                return 'technologie-title';
            default:
                return 'other-title'; // fallback
        }
    }

    const getBtnClassName = () => {
        switch(live.discipline){
            case 'economie':
                return 'btn-blue-secondary';
            case 'environnement':
                return 'btn-green';
            case 'education':
                return 'btn-purple';
            case 'sport':
                return 'btn-blue';
            case 'societe':
                return 'btn-orange';
            case 'science':
                return 'btn-green-alt';
            case 'international':
                return 'btn-blue-alt';
            case 'culture':
                return 'btn-purple-alt';
            case 'sante':
                return 'btn-green-secondary';
            case 'politique':
                return 'btn-danger';
            case 'technologie':
                return 'btn-blue-logo';
            default:
                return 'btn-grey';
        }
    }

      return (
    <Card className={classes.customCardVariant}>

        {/**Card header */}
         <Box className='live-card padding-wrapper cardHeaderFlex'>
            <Box className={`live-title centered-wrapper ${getCategoryClassName()}`}>
            
                <Box><i>Direct</i></Box> 
                <Box sx={{paddingLeft:'5px'}}><b>{live.discipline}</b></Box>
                <Box sx={{paddingLeft:'5px', paddingTop:0}}>
                    <FontAwesomeIcon
                    icon={faWifi} 
                    style={{ fontSize:'medium', rotate: '90deg', height: '16px'}} 
                />
                </Box>
                
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FontAwesomeIcon icon={getDisciplineIcon()} className={`${getCategoryClassName()}`} style={{float: 'right', height:'20px', paddingTop:'0px'}} />
            </Box>
        </Box>


        <Box className='large-separator'></Box>


        <Box className='large-padding-left large-padding-right padding-wrapper column-wrapper' sx={{minHeight:'73px'}}>
            <Typography className='cardSubtitle'>
                {new Date(live.dateTime).toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false, // 24h
            })}
            </Typography>
            <Typography className='cardTitle'>
                {live.name}
            </Typography>

        </Box>

        {/**Card content */}
        <Box sx={{minHeight:'328px', display: 'inline-grid', alignContent: 'space-around'}}>
        {/*NEW INTERFACE*/}
            <Box className='large-separator'></Box>
            <Box className='centered-column-wrapper padding-wrapper'>
                <Typography className='cardSubtitle' sx={{marginBottom:'0', paddingBottom:'0', fontSize:'small'}}><i>Nouvelle interface</i></Typography>
                <Link to={`/actualites/lives/${live._id}`} rel="noopener noreferrer">
                    <DsasButton
                    label={`Accéder au direct`}
                    customColorClassname={getBtnClassName()}
                    variant="flat"
                    />
                </Link>
            </Box>
            <Box className='large-separator'></Box>
        {/*OLD INTERFACE*/}
            <Box className='centered-column-wrapper padding-wrapper'>
                <Typography className='cardSubtitle' sx={{marginBottom:'0', paddingBottom:'0', fontSize:'small'}}><i>Ancienne interface</i></Typography>
                <DsasButton
                    label={`Accéder au direct`}
                    customColorClassname={getBtnClassName()}
                    variant="flat"
                    onClick={() => {
                    dispatch({ type: GET_LIVE_DETAILS, payload: {} });
                    navigate(`/divers/lives/${live._id}`);
                }}
                />
            </Box>
        </Box>
    <Box className='large-separator'></Box>

      {/* Boutons d'action */}
         {/**Card footer / Actions */}
         <Box className='cardActions'>
            <Box className='centered-column-wrapper'>
            <Can permission={PERMISSIONS.DIVERS_LIVES_HOME_BUTTON_DELETE}>
                <DsasButton 
                customCss={{ margin: '10px'}} 
                label='Supprimer' 
                icon={faTrashCan} 
                onClick={() => { dispatch(confirmActionNotification("Êtes-vous sûr de vouloir supprimer le direct ?", () => {
                                dispatch(deleteLive(live._id, (id) => {reload() ; addNotification({
                                title : "Suppression", 
                                type : "success", 
                                description : "Le live "+ live.name+" a été supprimé."
                                })}))
                })) }} 
                variant = 'secondary'
                customClass='smaller'
                />
            </Can>
            </Box>

            <Box className='large-vertical-separator'></Box>
                            
             <Box sx={{
                    display: 'grid',
                    margin:0
                }}>
                
                {/*Export button*/}
                <LiveExport idLive={live._id} isActu={true}/>
            </Box>
      </Box>
    </Card>
  );
};
    

export default Live